/**
 * SolyticsFlow — Edge Types barrel export.
 *
 * Individual edge components are exported for direct use by developers.
 * The `CustomEdgeTypes` map is passed to ReactFlow internally.
 */
export { default as SolidEdge } from './SolidEdge';
export { default as OffsetEdge } from './OffsetEdge';
export { default as DashedEdge } from './DashedEdge';
export { default as AccentEdge } from './SolidEdge';

import SolidEdge from './SolidEdge';
import OffsetEdge from './OffsetEdge';
import DashedEdge from './DashedEdge';

export const CustomEdgeTypes = {
  solid: SolidEdge,
  offset: OffsetEdge,
  dashed: DashedEdge,
  // Deprecated alias kept so older edge payloads continue to render.
  accent: SolidEdge,
};
